// Estilos compartilhados do tema "astro" (verde + preto, com planeta).
// Só aparência: cada página usa isto dentro do próprio makeStyles.

const escuroDe = (theme) => theme.palette.type === "dark";

// Banner verde de topo de página, com planeta e órbita decorativos.
// Todo texto dentro dele fica branco; botões "contained" viram brancos.
export const bannerAstro = (theme) => {
  const escuro = escuroDe(theme);
  return {
    position: "relative",
    overflow: "hidden",
    padding: "22px 26px",
    borderRadius: 18,
    color: "#ffffff",
    background: escuro
      ? "radial-gradient(420px 200px at 0% 100%, rgba(22,163,74,.24), transparent 70%), linear-gradient(120deg, #18201d 0%, #121816 60%, #151d1a 100%)"
      : "radial-gradient(420px 200px at 0% 100%, rgba(34,197,94,.20), transparent 70%), linear-gradient(120deg, #111816 0%, #151d1a 60%, #10261d 100%)",
    border: escuro ? "1px solid rgba(148,163,184,.14)" : "none",
    boxShadow: escuro ? "0 12px 32px rgba(0,0,0,.35)" : "0 12px 28px rgba(17,24,20,.16)",
    animation: "iaSubir .4s ease backwards",
    // planeta
    "&::before": {
      content: '""',
      position: "absolute",
      top: -46,
      right: "22%",
      width: 92,
      height: 92,
      borderRadius: "50%",
      background: escuro
        ? "radial-gradient(circle at 35% 30%, #4ade80 0%, #16a34a 45%, #064e2a 85%)"
        : "radial-gradient(circle at 35% 30%, #bbf7d0 0%, #4ade80 40%, #15803d 85%)",
      boxShadow: escuro ? "0 0 36px rgba(34,197,94,.35)" : "0 0 26px rgba(255,255,255,.25)",
      pointerEvents: "none",
    },
    // órbita tracejada
    "&::after": {
      content: '""',
      position: "absolute",
      right: -50,
      top: -50,
      width: 220,
      height: 220,
      borderRadius: "50%",
      border: `1px dashed ${escuro ? "rgba(255,255,255,.10)" : "rgba(255,255,255,.28)"}`,
      pointerEvents: "none",
    },
    "& > *": { position: "relative", zIndex: 1 },
    "& .MuiTypography-root, & h1, & h2, & h3, & h4, & h5, & h6": { color: "#ffffff" },
    "& .MuiTypography-colorTextSecondary, & p": {
      color: escuro ? "#94a3b8 !important" : "rgba(255,255,255,.85) !important",
    },
    "& .MuiSvgIcon-root": { color: "#ffffff" },
    "& .MuiButton-containedPrimary": {
      background: "#ffffff",
      color: "#1E9855",
      boxShadow: "0 6px 16px rgba(0,0,0,.15)",
      "& .MuiSvgIcon-root": { color: "#1E9855" },
      "&:hover": { background: "#f0fdf4" },
    },
    "& .MuiButton-outlined, & .MuiButton-text": {
      color: "#ffffff",
      borderColor: "rgba(255,255,255,.5)",
      "&:hover": { backgroundColor: "rgba(255,255,255,.12)" },
    },
  };
};

// Painel (caixa branca / verde-escura) com borda suave.
export const painelAstro = (theme) => {
  const escuro = escuroDe(theme);
  return {
    backgroundColor: theme.palette.background.paper,
    backgroundImage: escuro ? "linear-gradient(180deg, rgba(255,255,255,0.025), rgba(255,255,255,0))" : "none",
    border: escuro ? "1px solid rgba(148,163,184,.14)" : "1px solid #e3ece6",
    borderRadius: 16,
    boxShadow: escuro ? "0 8px 24px rgba(0,0,0,.3)" : "0 4px 14px rgba(16,40,28,.06)",
  };
};

// Cartão com linha colorida no topo, brilho no canto e hover que sobe.
export const cartaoAstro = (theme, cor = "#22c55e") => {
  const escuro = escuroDe(theme);
  return {
    ...painelAstro(theme),
    position: "relative",
    overflow: "hidden",
    transition: "transform .25s ease, box-shadow .25s ease, border-color .25s ease",
    animation: "iaSubir .4s ease backwards",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: 3,
      background: `linear-gradient(90deg, ${cor}, #4ade80)`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      borderColor: escuro ? "rgba(74,222,128,.35)" : "#bfe3cc",
      boxShadow: escuro
        ? "0 16px 36px rgba(0,0,0,.5), 0 0 22px rgba(34,197,94,.12)"
        : "0 14px 30px rgba(16,40,28,.12)",
    },
  };
};

// Texto escuro em etiqueta clara (ex.: salmão, amarelo) e branco nas escuras.
export const corDoTextoDaEtiqueta = (hex) => {
  const h = String(hex || "").replace("#", "");
  if (!/^[0-9a-f]{6}$/i.test(h)) return "#ffffff";
  const n = parseInt(h, 16);
  const r = (n >> 16) & 255;
  const g = (n >> 8) & 255;
  const b = n & 255;
  const luz = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luz > 0.68 ? "#1f293b" : "#ffffff";
};

// Título de seção com barrinha verde à esquerda.
export const tituloSecaoAstro = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: 10,
  fontSize: "0.74rem",
  fontWeight: 800,
  letterSpacing: "0.1em",
  textTransform: "uppercase",
  color: escuroDe(theme) ? "#cbd5e1" : "#1f3a2b",
  "&::before": {
    content: '""',
    width: 4,
    height: 16,
    borderRadius: 2,
    background: "linear-gradient(180deg, #22c55e, #16a34a)",
  },
});
